"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = exports.Dice = exports.Board = void 0;
var tslib_1 = require("tslib");
exports.Board = tslib_1.__importStar(require("./board"));
exports.Dice = tslib_1.__importStar(require("./dice"));
exports.State = tslib_1.__importStar(require("./state"));
//# sourceMappingURL=index.js.map